module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8712/img/pumpkin.svg"